import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class DistrictService {

    getEventRoute = '/api/district/';

    constructor(private dataService: DataService) {
    };

    getLookUp(refresh: boolean) {
        return this.dataService.getData('/api/lookup/district', refresh);
    }

    getLookUpDistrict(langType: any, refresh: boolean) {
        return this.dataService.getData('/api/district/' + langType, refresh);
    }

    getLookUpAll(refresh: boolean) {
        return this.dataService.getData('/api/lookup/alldistrict', refresh);
    }

    // getLookUpDelta(refresh: boolean) {
    //     return this.dataService.getData('/api/lookup/blocktype', refresh);
    // }

    get(refresh: boolean) {
        return this.dataService.getData('/api/district', refresh);
    }

    getById(id: number, refresh: boolean) {
        return this.dataService.getData('/api/district/' + id, refresh);
    }

    save(result: any) {
        return this.dataService.post('/api/district', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    delete(id: number) {
        return this.dataService.delete('/api/district/' + id).map(response => {
            this.dataService.clearCache();
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getProduct(langtype: number, refresh: boolean) {
        return this.dataService.getData('/api/district/' + langtype, refresh);
    }
    getvillage(talukId: number,langType:number, refresh: boolean) {
        return this.dataService.getData('/api/villagepanchayatList/' + talukId+'/'+langType, refresh);
    }
    gettaluk(districtId: number,langType:number, refresh: boolean) {
        return this.dataService.getData('/api/TalukList/' + districtId+'/'+langType, refresh);
    }
    talukreport(districtId: number, langType: number, refresh: boolean) {
        return this.dataService.getData('/api/lookup/taluk/' + districtId + '/' + langType, refresh);
      }
    dashboarddata(districtId: number, TalukId: number, VillagepanchayatId, refresh: boolean) {
        return this.dataService.getData('/api/TypesofLibrary/' + districtId + '/' + TalukId + '/' + VillagepanchayatId, refresh)
    }
    buildingstatus(districtId: number, TalukId: number, VillagepanchayatId, refresh: boolean) {
        return this.dataService.getData('/api/BuildingStatus/' + districtId + '/' + TalukId + '/' + VillagepanchayatId, refresh)


    }
    librarycount(todaydate: number, districtId: number, TalukId: number, VillagepanchayatId, refresh: boolean) {
        return this.dataService.getData('/api/LibraryOpenCount/' + todaydate + '/' + districtId + '/' + TalukId + '/' + VillagepanchayatId, refresh)


    }
    libraryopendate(districtId: number, TalukId: number, VillagepanchayatId, refresh: boolean) {
        return this.dataService.getData('/api/LibararyOpenDateWiseCount/' + districtId + '/' + TalukId + '/' + VillagepanchayatId, refresh)
    }
    membercount(districtId: number, TalukId: number, VillagepanchayatId: number, refresh: boolean) {
        return this.dataService.getData('/api/MemberCount/' + districtId + '/' + TalukId + '/' + VillagepanchayatId, refresh)
    }
    employee(districtId: number, TalukId: number, VillagepanchayatId: number, refresh: boolean) {
        return this.dataService.getData('/api/LibrarianCount/' + districtId + '/' + TalukId + '/' + VillagepanchayatId, refresh)
    }
    typeoflibrary(districtId: number, TalukId: number, VillagepanchayatId, refresh: boolean){
        return this.dataService.getData('/api/TotalFOLCount/'+ districtId + '/' +TalukId + '/' +VillagepanchayatId,refresh)
    }
    getdasboard(districtId: number, TalukId: number, VillagepanchayatId, refresh: boolean){
        return this.dataService.getData('/api/OverallDashboard/'+ districtId + '/' +TalukId + '/' +VillagepanchayatId,refresh)
    }
   
}
